<template>
    <div class="st-main-content">
		<div></div>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:loading="false"
				:showPage="false"
				>
			</common-table>
		</div>
		<st-dialog title="参数设置"  :toggleStDialog="toggleStDialog" @closeDialog="toggleStDialog=false" @saveDialog="saveDialogForm">
			<div class="st-dialog-content">
				<ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title">配置值</div>
						<div class="st-dialog-item-input"><input type="text" v-model="configValue" ></div>
					</li>
					<li v-if="this.configKey=='peak_fee'">
						<div class="st-dialog-item-title">是否启用</div>
						<div class="st-dialog-item-input"> <el-checkbox v-model="status"></el-checkbox></div>
					</li>
				</ul>
			</div>
		</st-dialog>
    </div>
</template>
<script>
import stDialog from '../../components/StDialog'

export default {
	name: 'PlatformSetting',
	props: [],
	components: {stDialog},
	data(){
		return{
			tableColumns:[
				{
					key: '',
					title: '设置',
					width:'100',
					align:'center',
					operate:true,
					setBtns:(row,index)=>{
						return [
							{
								label:'编辑',
								handler: (row,index) => this.setList(row)
							}
						]
					}
				},{
					key:'configValue',
					title:'配置值',
					align:'center',
				},{
					key:'configKey',
					title:'配置key',
					align:'center',
				},{
					key:'lastUpdateTmFormatted',
					title:'最近更新日期',
					align:'center',
				},{
					key:'remark',
					title:'备注',
					align:'center',
				},{
					key:'terminalDesc',
					title:'所属平台类型',
					align:'center',
				},{
					key:'statusDest',
					title:'启用状态',
					align:'center',
				}
			],
			toggleStDialog:false,//控制弹窗
			dataList:[],
			createTimeBegin:'',
			configKey:null ,//配置key
			configValue:null, //配置值
			status:false
		}
	},
	created() {},
	methods: {
		saveDialogForm(){
			let data={};
			data.configKey=this.configKey;
			data.configValue=this.configValue;
			data.status=this.status
			
			this.$server.system.setConfig([data],res=>{
				this.getInfo()
			})
			this.toggleStDialog=false;
		},
		getInfo(){
			let data={};
			this.$server.system.configPage(data,res=>{
				this.dataList=res.data.records;
			})	
		},
		setList(row){
			this.toggleStDialog=true;
			this.configKey=row.configKey;
			this.configValue=row.configValue;
			this.status=row.status;
		}
	},
	mounted() {
		this.getInfo()
		
	}
}

</script>
<style scoped>
.platform-setting {
  width: 100%;
  height: auto;
}
.query-setting-box-left{
	flex-grow: 0;
}
.platform-set-title{
	color: #B5B5B5;
	padding-left: 8px;
	padding-top: 24px;
	font-weight: 600;
}
.createStartTime{
	display: inline-block;
	width: 90px;
	height: 22px;
	line-height: 22px;
	background-color: #32BB57;
	color: #fff;
	padding-left: 4px;
	border-radius:2px 2px 0px 0px;
}
.createStartTime i, .creatEndTime i{
	display: inline-block;
	width: 12px;
	height: 12px;
	background: url('../../assets/images/icon_select.png') center no-repeat;
	background-size: 100% 100%;
	margin-left: 12px;
	vertical-align: middle;
}
.creatEndTime{
	display: inline-block;
	width: 90px;
	height: 22px;
	line-height: 22px;
	background-color: #FF5B3E;
	color: #fff;
	padding-left: 4px;
	border-radius:2px 2px 0px 0px;
}
/* 弹窗内 */
/*  */
.st-dialog-content{
	/* min-height: 100px; */
	padding: 0 32px;
}
.st-dialog-form{
	width: 406px;
	display: flex;
	justify-content:center;
	align-items: center;
}
.st-dialog-form li {
	width: 156px;
	margin: 0 10px;
	padding: 13px 0;
}

.st-dialog-form .st-dialog-item-title{
	height: 20px;
	line-height: 20px;
}
.st-dialog-form .st-dialog-item-title i{
	color: #FF5B3E;
}
.st-dialog-form .st-dialog-item-input input{ 
	width: 156px;
	height: 30px;
	text-indent: 8px;
	border-radius: 2px;
	border: 1px solid #DCDCDC;
	box-sizing: border-box;
}
.setConfig{
	cursor: pointer;
}
/* end */
</style>
